import { render, staticRenderFns } from "./PostbacksList.vue?vue&type=template&id=5fbc814c&scoped=true&"
import script from "./PostbacksList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PostbacksList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PostbacksList.vue?vue&type=style&index=0&id=5fbc814c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc814c",
  null
  
)

export default component.exports